module.exports = __webpack_public_path__ + "static/media/cross.18d35121.svg";